// 发布通知表单提交前校验（独立模块，便于单元测试与复用）
// 返回空字符串表示校验通过，否则返回第一条错误提示（按表单字段顺序）
// 定时发送时间与强制弹窗天数为条件必填：仅在选择对应发送/弹窗方式时校验

const hasRichContent = (html) => {
  const value = html || ''
  const text = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, '').trim()
  const hasMedia = /<(img|video|iframe|audio)[^>]*>/i.test(value)
  return Boolean(text) || hasMedia
}

const validateNotificationForm = (form) => {
  if (!form.createUser) {
    return '请选择发布人'
  }
  if (form.isDelay && !form.scheduleSendTime) {
    return '请选择定时发送时间'
  }
  if (form.isForcePopover === 1 && !form.forcePopoverTimeLimit) {
    return '请输入强制弹窗天数'
  }
  if (!form.title || !String(form.title).trim()) {
    return '请输入通知标题'
  }
  if (!hasRichContent(form.content)) {
    return '请输入通知正文'
  }
  return ''
}

module.exports = {
  hasRichContent,
  validateNotificationForm,
}
